<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">

      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true" label-width="80px"
        :rules="rules">
        <el-row>
          <el-col :span="8">
            <el-form-item label="班级" prop="name">
              <el-input v-model="formParameter.name" placeholder="请输入班级名称" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
    
          <el-col :span="8">
            <el-form-item label="默认密码" prop="deftpwd">
              <el-input v-model="formParameter.deftpwd" placeholder="请输入密码" autocomplete="off">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="所属课程" prop="cid">
              <el-select v-model="formParameter.cid" placeholder="请选择课程">
                <el-option v-for="item in courseName" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8"> 
            <el-form-item label="类型" prop="state">
              <select-option-dictionary v-model="formParameter.types" dkey="clazz-types">
              </select-option-dictionary>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="状态" prop="state">
              <select-option-dictionary v-model="formParameter.state" dkey="clazz-state">
              </select-option-dictionary>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="8">
            <el-form-item label="预科时间" prop="preptime">
              <el-date-picker v-model="formParameter.preptime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="开班时间" prop="starttime">
              <el-date-picker v-model="formParameter.starttime" type="date" value-format="yyyy-MM-dd"
                placeholder="选择日期"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="结课时间" prop="endtime">
              <el-date-picker v-model="formParameter.endtime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input type="textarea" placeholder="请输入..." :autosize="{ minRows: 5, maxRows: 8 }"
                v-model="formParameter.remark" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <el-button size="mini" type="success" @click="addTeacher">添加带班老师</el-button>
        </el-row>
        <el-row v-for="(htr, idx) in historyteacher" :key="idx">
          <el-col :span="6">
            <el-form-item :label="'带班老师' + (idx + 1)">
              <el-input readonly v-model="htr.teacher" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-input readonly v-model="htr.time" autocomplete="off"></el-input>
          </el-col>
          <el-col :span="4">
            <el-input readonly v-model="htr.time2" autocomplete="off"></el-input>
          </el-col>
          <el-col v-if="!disabled" :span="4">
            <el-button @click="delhTcr(idx)">删除</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="绑定wifi" prop="wlist">
              <el-select v-model="formParameter.wlist" :clearable="true" :filterable="true" multiple placeholder="添加wifi">
                <el-option v-for="v in selectWifiList" :key="v.id" :label="v.name" :value="v.id"> </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-checkbox v-model="wifiSelectAllFlag" @change="wifiSelectAll()">全选</el-checkbox>
          </el-col>
        </el-row>

      </el-form>

      <el-dialog title="上传学生信息" :visible.sync="dialogVisible" width="30%"  :modal="false"  :before-close="handleDlgClose">
        <div>
          <el-row>
            <el-col :span="24">
              请选择老师：<el-select v-model="teacheridx" placeholder="请选择老师">
                <el-option v-for="(item,idx) in teachers" :key="item.name" :label="item.name" :value="idx"></el-option>
              </el-select>
            </el-col>
            <el-col :span="24">
              请接班日期：
                <el-date-picker  value-format="yyyy-MM-dd" v-model="beginDate" type="date" placeholder="选择日期">
                </el-date-picker>
            </el-col>
          </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="changeTeacher"> {{  this.historyteacher.length>0?"确定换老师":"分配老师" }}   </el-button>
        </span>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-button v-if="!disabled" type="primary" :loading="confirmLoading" @click="confirm()">确 定</el-button>
      <el-button @click="close">取 消</el-button>
      <div>
      </div>
    </div>

  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import clazzapi from "@/api/edu/clazz/clazz.js";
import userapi from "@/api/system/user/user.js";
import courseapi from "@/api/edu/course/course.js";
import selectOptionDictionary from "@/components/biz/selectOptionDictionary/selectOptionDictionary.vue";
import wifiapi from '@/api/system/wifi/wifi.js';
export default {
  name: "edit",
  components: {
    popup,
    selectOptionDictionary,
  },
  data() {
    return {
      // checkAll: false,
      // checkedCourse: [],
      // isIndeterminate: true,
      prepTime: "",
      flag: "",
      disabled: false,
      courseName: [],
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {deftpwd:"888888"},
      historyteacher: [],

      teacheridx:0,
      teachers:[],
      beginDate:"",

      //wifi列表
      selectWifiList:[],
      wifiSelectAllFlag:false,

      dialogVisible: false,  //添加老师
      rules: {
        //班级名称
        name: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: 'blur'
          }
        ],
        //课程id
        cid: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: 'blur'
          }
        ],
        //类型：1-线上推广班，2-线下推广班，3-培训班
        types: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 16,
            trigger: 'blur'
          }
        ],
        //状态：预科，授课
        state: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 16,
            trigger: 'blur'
          }
        ],
        //预科时间
        preptime: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: 'blur'
          }
        ],
        //开班时间
        starttime: [
          {
            validator: this.$validate.required,
            trigger: 'blur'
          },
          {
            validator: this.$validate.length,
            max: 32,
            trigger: 'blur'
          }
        ]
   
      },
    };
  },
  watch: {
    checkedCourse: function (a, b) { },
  },

  methods: {
    addTeacher() {
      this.dialogVisible = true
    },
    handleDlgClose() {
      this.dialogVisible = false
    },
    changeTeacher(){

      //以前的
      if( this.historyteacher.length>0){
        this.historyteacher[this.historyteacher.length -1].time2=this.beginDate
      }

      let tchr = this.teachers[this.teacheridx]
      this.historyteacher.push({"time2":"现在","teacher":tchr.name,"time":this.beginDate});
      this.teacheridx=0
      this.beginDate =''
      this.dialogVisible = false
    },
    delhTcr(idx) {
      this.historyteacher.splice(idx, 1);
    },
    //打开弹框
    open(parameter, title, disabled) {

      this.formParameter = parameter;
 
      if (this.formParameter.historyteacher) {
        this.historyteacher = JSON.parse(this.formParameter.historyteacher)
      }
      this.disabled = disabled;
      this.flag =  this.formParameter.tid;
      this.prepTime =  this.formParameter.preptime;

      if( this.formParameter.wid ){
        let wlist = JSON.parse(this.formParameter.wid)
      
        if(   wlist.length==this.selectWifiList.length){
            this.wifiSelectAllFlag = true;
         }else{
             this.wifiSelectAllFlag = false;
         }
          this.$set(this.formParameter,"wlist",wlist);
        
      }

      this.$refs.popup.open(title, "70%");
      //这里获取该班级选中的wifi值
     /* wifiapi.bindWifiList(params,(res)=>{
        let  wlist = [];
        for(let i =0;i<res.data.length;i++){
           wlist.push(res.data[i].id);  
        }
        //这里需要使用set方法来完成动态绑定，不然属性的修改无法更新渲染
        
          console.log(wlist.length==this.selectWifiList.length);
          if(wlist.length==this.selectWifiList.length){
            this.wifiSelectAllFlag = true;
          }else{
             this.wifiSelectAllFlag = false;
          }
      });*/
    },
    open2(parameter, title, disabled) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title, "70%");
    },
    //获取课程名称
    toCourseName() {
      this.listLoading = true;
      courseapi.inuseCourses({}, (res) => {
        this.courseName = res.data;
        this.listLoading = false;
      });
    },
    //
    wifiSelectAll(){
        if(this.wifiSelectAllFlag){      
           let  wlist = [];
        for(let i =0;i<this.selectWifiList.length;i++){
           wlist.push(this.selectWifiList[i].id);  
        }
          this.formParameter.wlist = wlist;
        }else{
          this.formParameter.wlist = [];      
        }
    },

    toWifiSelect(){
      wifiapi.selectList({},(res)=>{
        this.selectWifiList = res.data;
      });
    },

    //关闭弹框
    close() {
      this.disabled = false;
      this.formParameter={deftpwd:"888888"}
      this.historyteacher = []
      this.$refs.popup.close();
      //父页面强制刷新
      this.$parent.list();
    },

    //提交表单
    confirm() {
    
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;

        if(this.historyteacher && this.historyteacher.length>0){
             this.formParameter.historyteacher = this.historyteacher;
            }
        let parameter = this.$utils.merger(this.formParameter);
        if (!this.formParameter.id) {
          //添加
      
          clazzapi.save(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
          
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else { 
          clazzapi.update(
            parameter,
            (response) => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            (err) => {
              this.$utils.msg.warning(err.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    }

  },
  mounted() {

    this.toCourseName();
    this.toWifiSelect();
     //加载teachers
     userapi.list2({},res=>{
      console.log("this.teachers", res)
          this.teachers = res.data.records
    })
    
  
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";



</style>
